import { useState } from 'react';
import { flushSync } from 'react-dom';
import { Button } from 'ui';

import { SignInTab } from '../SignInTab';
import { SignUpTab } from '../SignUpTab';

import styles from './SignTabs.module.scss';
import { Tab, SignTabsProps } from './types';
import { useTranslation } from '@/i18n/client';

export const SignTabs = ({ onAuthModalClose }: SignTabsProps) => {
	const { t } = useTranslation(['header']);
	const [activeTab, setActiveTab] = useState<Tab>('signIn');
	const [remindPasswordActive, setRemindPasswordActive] = useState(false);
	const [changePasswordActive, setChangePasswordActive] = useState<string | null>(null);
	const [signUpFormSent, setSignUpSent] = useState<null | string>(null);

	const handleSignInTabPress = () => {
		flushSync(() => {
			setRemindPasswordActive(false);
			setSignUpSent(null);
		});
		setActiveTab('signIn');
	};

	const handleSignUpPress = () => {
		setActiveTab('signUp');
	};

	return (
		<div className={styles.signTabs__container}>
			<div className={styles.signTabs__navigation}>
				<Button
					buttonName={activeTab === 'signIn' ? 'activeButton' : 'inactiveButton'}
					onPress={handleSignInTabPress}
				>
					{t('authModal.signInTab')}
				</Button>
				<Button
					buttonName={activeTab === 'signUp' ? 'activeButton' : 'inactiveButton'}
					onPress={handleSignUpPress}
				>
					{t('authModal.signUpTab')}
				</Button>
			</div>
			<SignInTab
				active={activeTab === 'signIn'}
				changePasswordActive={changePasswordActive}
				remindPasswordActive={remindPasswordActive}
				backToLoginPress={handleSignInTabPress}
				setChangePasswordActive={setChangePasswordActive}
				setRemindPasswordActive={setRemindPasswordActive}
				onAuthModalClose={onAuthModalClose}
			/>
			<SignUpTab
				active={activeTab === 'signUp'}
				signUpFormSent={signUpFormSent}
				backToLoginPress={handleSignInTabPress}
				setSignUpFormSent={setSignUpSent}
			/>
		</div>
	);
};
